import axios from 'axios';
import store from '../../store';
import { usersApi } from '../apis';
import { isTripord } from '../../utils/consts/general';
import { SignOutClearStore } from '../../utils/clearData';
import { setRefreshToken, setToken } from '../../actions/requestToken';
const config = {
  baseURL: isTripord
    ? `${process.env.REACT_APP_API_TRIPORD_URL}`
    : `${process.env.REACT_APP_API_TRIPSI_URL}`,
  timeout: 70000,
  credentials: 'same-origin',
  onUploadProgress: () => {},
  onDownloadProgress: () => {},
  validateStatue: (status) => status < 500,
  maxRedirect: 5,
};

const ApiCreator = async ({
  method,
  url,
  baseURL,
  data,
  headers = {},
  error,
}) => {
  const customConfig = {
    ...config,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${
        store.getState()?.requestToken?.barearToken || ''
      }`,
      ...headers,
    },
    url,
    method,

    data,
    withCredentials: true,
  };

  try {
    const res = await axios(customConfig);
    return res?.data;
  } catch (err) {
    if (err?.response?.status === 401) {
      if (store.getState()?.requestToken?.refreshToken) {
        return await usersApi
          .RefreshToken({ token: store.getState()?.requestToken?.refreshToken })
          .then((result) => {
            store.dispatch(
              setRefreshToken(result?.payload?.data?.refresh_token),
            );
            store.dispatch(setToken(result?.payload?.data?.token));

            return ApiCreator(
              method,
              url,
              baseURL,
              data,
              (headers = {}),
              error,
            );
          })
          .catch((error) => {
            SignOutClearStore();
          });
      } else {
        SignOutClearStore();
      }
    } else if (err?.response?.status === 403) {
      return err;
    }
    throw err?.response;
  }
};
class Api {
  /**
   * GET method
   * @param {Object} api
   * @param {String} api.headers
   * @param {String} api.url
   * @param {String} api.baseURL
   */
  static GET = (api) => {
    return ApiCreator({
      headers: api.headers,
      method: 'get',
      url: api.url,
      baseURL: api.baseURL,
    });
  };
  /**
   * POST method
   * @param {Object} api
   * @param {Object} api.data
   * @param {String} api.headers
   * @param {String} api.url
   * @param {String} api.baseURL
   */
  static POST = (api) =>
    ApiCreator({
      headers: api.headers,
      method: 'post',
      url: api.url,
      data: api.data,
      baseURL: api.baseURL,
    });

  /**
   * STREAM method
   * @param {Object} api
   * @param {Object} api.data
   * @param {String} api.headers
   * @param {String} api.url
   * @param {String} api.baseURL
   */
  static STREAM = async (api) => {
    let { method = 'post', url, baseURL, data, headers = {} } = api;

    const customConfig = {
      ...config,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${
          store.getState()?.requestToken?.barearToken || ''
        }`,
        ...headers,
      },
      url,
      method,
      data,
      withCredentials: true,
    };

    try {
      const response = await axios({
        ...customConfig,
        responseType: 'stream',
      });

      return response.data;
    } catch (err) {
      if (err?.response?.status === 401) {
        if (store.getState()?.requestToken?.refreshToken) {
          return await usersApi
            .RefreshToken({
              token: store.getState()?.requestToken?.refreshToken,
            })
            .then((result) => {
              store.dispatch(
                setRefreshToken(result?.payload?.data?.refresh_token),
              );
              store.dispatch(setToken(result?.payload?.data?.token));

              return ApiCreator(
                method,
                url,
                baseURL,
                data,
                (headers = {}),
                error,
              );
            })
            .catch((error) => {
              SignOutClearStore();
            });
        } else {
          SignOutClearStore();
        }
      } else if (err?.response?.status === 403) {
        return err;
      }
      throw err?.response;
    }
  };

  /**
   * PUT method
   * @param {Object} api
   * @param {Object} api.data
   * @param {String} api.headers
   * @param {String} api.url
   * @param {String} api.baseURL
   */
  static PUT = (api) =>
    ApiCreator({
      headers: api.headers,
      method: 'put',
      url: api.url,
      data: api.data,
      baseURL: api.baseURL,
    });
  /**
   * PATCH method
   * @param {Object} api
   * @param {Object} api.data
   * @param {String} api.headers
   * @param {String} api.url
   * @param {String} api.baseURL
   */
  static PATCH = (api) =>
    ApiCreator({
      headers: api.headers,
      method: 'PATCH',
      url: api.url,
      data: api.data,
      baseURL: api.baseURL,
    });
  /**
   * DELETE method
   * @param {Object} api
   * @param {Object} api.data
   * @param {String} api.headers
   * @param {String} api.url
   * @param {String} api.baseURL
   */
  static DELETE = (api) =>
    ApiCreator({
      headers: api.headers,
      method: 'DELETE',
      url: api.url,
      data: api.data,
      baseURL: api.baseURL,
    });

  static HEAD = (api) => {
    return ApiCreator({
      headers: api.headers,
      method: 'HEAD',
      url: api.url,
      baseURL: api.baseURL,
    });
  };
}

export default Api;
